import { createSlice } from "@reduxjs/toolkit";

const slice = createSlice({
  name: "organisationConversionData",
  initialState: { organisation: null },
  reducers: {

    organisationConversionDataInitialised: (state, action) => {
      const data = action.payload.data;
      const orgData = Array.isArray(data) ? data[0] : data;
      if (!orgData) return;

      state.organisation = { id: orgData.Id, metrics: [] };

      orgData.MetricsData.forEach(metricData => {

        const timePeriods = metricData.TimePeriodData.map(o => ({
          period: o.Period,
          value: o.FormattedValue,
          valueNumeric: o.Value ?? 0,
          trend: o.Trend,
          previousPeriodText: o.PreviousPeriodText,
          targetText: o.TargetText ?? null,
          target: o.Target ?? null
        }));

        state.organisation.metrics.push({ id: metricData.Id, timePeriods });
      });
    },

    organisationMetricValuesUpdated: (state, action) => {
      if (!state.organisation || state.organisation.id !== action.payload.data.Id) return;

      action.payload.data.MetricsData.forEach(metricData => {
        const metric = state.organisation.metrics.find(o => o.id === metricData.Id);
        if (metric) {
          metricData.TimePeriodData.forEach(o => {
            const timePeriod = metric.timePeriods.find(tp => tp.period === o.Period);
            if (timePeriod) {
              timePeriod.value = o.FormattedValue;
              timePeriod.valueNumeric = o.Value ?? 0;
              timePeriod.trend = o.Trend;
              timePeriod.previousPeriodText = o.PreviousPeriodText;
              timePeriod.targetText = o.TargetText ?? null;
              timePeriod.target = o.Target ?? null;
            }
          });
        }
      });
    },

  },
});

export const { organisationConversionDataInitialised, organisationMetricValuesUpdated } = slice.actions;
export default slice.reducer;

function getMetricIdAndValue(state, period, index) {
  if (!period || !state.organisation) return null;
  if (index >= state.organisation.metrics.length) return null;

  let metricId = null;
  let value = null;
  let valueNumeric = null;
  let trend = null;
  let previousPeriodText = null;
  let targetText = null;
  let target = null;

  state.organisation.metrics[index].timePeriods.forEach(o => {
    if (o.period === period) {
      metricId = state.organisation.metrics[index].id;
      value = o.value;
      valueNumeric = o.valueNumeric;
      trend = o.trend;
      previousPeriodText = o.previousPeriodText;
      targetText = o.targetText;
      target = o.target;
    }
  });

  return metricId ? { id: metricId, value, valueNumeric, trend, previousPeriodText, targetText, target } : null;
}

export const getMetric1IdAndValue = (state, period) =>
  getMetricIdAndValue(state, period, 0);

export const getMetric2IdAndValue = (state, period) =>
  getMetricIdAndValue(state, period, 1);
